function formatMoneyCents(cents) {
  const amount = parseInt(cents || 0, 10) / 100;

  // If Shopify.formatMoney exists, still respect it
  try {
    if (window.Shopify && typeof Shopify.formatMoney === "function") {
      const fmt =
        window.Shopify.money_format ||
        (window.theme && window.theme.moneyFormat) ||
        "${{amount}}";
      return Shopify.formatMoney(cents, fmt);
    }
  } catch (e) {}

  // ✅ Custom Rs. prefix
  return `$${amount.toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
}

if (!customElements.get("pair-well-with")) {
  customElements.define(
    "pair-well-with",
    class PairWellWith extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.variantIdInput = this.form.querySelector("[name=id]");

        const urlVariantId = new URLSearchParams(window.location.search).get(
          "variant"
        );
        if (urlVariantId) {
          this.variantIdInput.value = urlVariantId;
        }

        this.submitButton = this.form.querySelector('button[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector("span");
        this.pairWellAtc = this.form.querySelector(".second-atc-quantity");

        this.checkboxes = document.querySelectorAll(".shop-the-look-checkbox");
        this.totalPriceElement = document.getElementById(
          "shop-the-look-total-price"
        );

        if (this.totalPriceElement && this.checkboxes.length) {
          this.initShopTheLook();
        }
      }

      initShopTheLook() {
        this.submitButton.disabled = true;
        this.submitButton.classList.add("disabled-button");

        this.checkboxes.forEach((checkbox) => {
          // debugger
          checkbox.addEventListener("change", () => {
            this.updateTotalPrice();
            this.updateButtonState();
          });
        });

        document
          .querySelectorAll(".shop-the-look-size-selector")
          .forEach((selector) => {
            selector.addEventListener("change", (e) => {
              this.updateTotalPrice();
              this.updateButtonState();
              this.updateVariantImage(e.target);
            });
          });

        const mainQtyInput = document.querySelector(
          ".quantity-selector__input"
        );
        if (mainQtyInput) {
          mainQtyInput.addEventListener("change", (e) => {
            this.updateTotalPrice();
            this.syncBundleMainProductQty(e.target.value);
          });
        }

        this.updateTotalPrice();
        this.updateButtonState();
      }

      updateVariantImage(selector) {
        const selectedOption = selector.selectedOptions[0];
        if (!selectedOption) return;
        const newImage = selectedOption.dataset.image;
        const newPriceCents = parseInt(selectedOption.dataset.price || "0", 10);

        if (newImage) {
          const itemContainer = selector.closest(".shop-the-look-item");
          const picture = itemContainer.querySelector(
            ".shop-the-look-image picture"
          );
          const imgTag = picture?.querySelector("img");

          if (imgTag) {
            imgTag.src = newImage;
            imgTag.srcset = newImage;
          }
          if (picture) {
            picture.querySelectorAll("source").forEach((source) => {
              source.srcset = newImage;
            });
          }

          // 🔹 Update the displayed price for this item
          const priceTag = itemContainer.querySelector(".shop-the-look-price");
          if (priceTag) {
            priceTag.dataset.priceRaw = String(newPriceCents);
            priceTag.innerHTML = `<span class="money" data-cents="${newPriceCents}">${formatMoneyCents(
              newPriceCents
            )}</span>`;
          }
        }

        this.updateTotalPrice();
      }

      updateTotalPrice() {
        const mainproductInput = document.querySelector(
          ".quantity__input-primary"
        );
        const mainproductQty = parseInt(mainproductInput?.value || "1", 10);

        // ✅ main product subtotal (in dollars)
        let total =
          (parseFloat(this.totalPriceElement.dataset.basePrice) / 100) *
          mainproductQty;

        this.checkboxes.forEach((checkbox) => {
          if (checkbox.checked) {
            const item = checkbox.closest(".shop-the-look-item");
            const variantSelector = item.querySelector(
              ".shop-the-look-size-selector"
            );
            let price = 0;

            if (variantSelector) {
              const selectedOption = variantSelector?.selectedOptions?.[0];

              // ✅ if variant exists but none is selected → treat as 0
              if (selectedOption && selectedOption.value) {
                price = parseFloat(selectedOption.dataset.price || "0") / 100;
              } else {
                price = 0; // no variant chosen → no extra cost
              }
            } else {
              // no variant selector → fallback to checkbox dataset
              price = parseFloat(checkbox.dataset.price || "0") / 100;
            }

            if (!isNaN(price)) {
              total += price;
            }
          }
        });

        this.totalPriceElement.innerText = new Intl.NumberFormat("en-US", {
          style: "currency",
          currency: "USD",
        }).format(total);
      }

      updateButtonState() {
        let anyChecked = false;
        let allValid = true;

        this.checkboxes.forEach((checkbox) => {
          if (checkbox.checked) {
            anyChecked = true;

            const variantSelector = checkbox
              .closest(".shop-the-look-item")
              .querySelector(".shop-the-look-size-selector");

            if (!variantSelector || !variantSelector.value) {
              allValid = false;
            }
          }
        });

        if (anyChecked && allValid) {
          this.submitButton.disabled = false;
          this.submitButton.classList.remove("disabled-button");
        } else {
          this.submitButton.disabled = true;
          this.submitButton.classList.add("disabled-button");
        }
      }
    }
  );
}
